// extracted by mini-css-extract-plugin
export var borderRadius = "_bh-4";
export var large = "_bh-3";
export var logoContainer = "_bh-0";
export var nameLogo = "_bh-2";
export var small = "_bh-1";